import {
	TemplatePreview,
	TemplatePreviewLoading
} from 'app-js/components/TemplatePreview/TemplatePreview';

export { TemplatePreview, TemplatePreviewLoading };



// WEBPACK FOOTER //
// ./src/public/js/components/TemplatePreview/index.js